export default String.raw`

function handleCredentialResponse(response) {
  setTimeout(function() {
    $.post(null,{ __action: 'External/GoogleLogin', __csrf: __CSRF, id_token: response.credential },function(result){
      if (result.action.Result) {
          window.location.replace('');
      } else if (result.action.Code === 108) {
        app.temporaryPopupMessage(undefined, __translations.CantLoginWithGoogle, result.action.Type);
      } else {
        app.temporaryPopupMessage(undefined, __translations.CantLoginWithGoogle, result.action.Type);
      }
    });
  }, 1000);
}

windowOnloadAdd(initGoogle);
function initGoogle() {
    google.accounts.id.initialize({client_id: __googleID, callback: handleCredentialResponse})
    google.accounts.id.renderButton(
      document.getElementById("google-signin"),
      { theme: "outline", size: "large", width: "250px", logo_alignment: "center", text: "signin_with"}
    );

    $('body').on('click', '#linkGoogleAccount', function(){
        setTimeout(function() {
        $.post(null,{ __action: 'External/GoogleAccountLink', __csrf: __CSRF, userID: __googleID },function(result){
            if (result.action.Result) {
                location.reload();
            } else {
                app.temporaryPopupMessage(undefined, __translations.FailedConnectToGoogle, result.action.Type);
            }
        });
        }, 1000);
    });

  $('body').on('click', '#unlinkGoogleAccount', function(){
    $.post(null,{ __action: 'External/GoogleAccountUnlink', __csrf: __CSRF },function(result){
        if (result.action.Result) {
            location.reload();
        } else {
            app.temporaryPopupMessage(undefined, __translations.FailedDisconnectFromGoogle, result.action.Type);
        }
    });
  });

    $('body').on('click', '.logout', function () {
        googleLogout();
    });
}

function googleLogout() {
  const auth2 = gapi.auth2.getAuthInstance();
  auth2.signOut();
}
`